import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import Typography, { TypographyProps } from '@mui/material/Typography';
import isEmpty from 'lodash/fp/isEmpty';

import type { TalentBoardComment as TalentBoardCommentType } from '@bloomays-lib/types.shared';
import { Title } from '@bloomays-lib/ui.shared';

import { TalentBoardCommentForm } from '../molecules/TalentBoardCommentForm';
import { TalentBoardComment } from '../molecules/TalentBoardComment';

type TalentBoardCommentListProps = {
  comments: TalentBoardCommentType[];
  isClient: boolean;
  jobId: string;
  talentId: string;
};

const TalentBoardCommentList = ({ comments, isClient, jobId, talentId }: TalentBoardCommentListProps) => {
  const { t } = useTranslation('talentBoard');

  return (
    <CommentList>
      <Title textTitle={t('talentJob.comments')} variant="heading6" sx={{ textAlign: 'left' }} />
      {!isEmpty(comments) &&
        comments.map((comment) => <TalentBoardComment key={comment.id} comment={comment} isClient={isClient} />)}
      {isEmpty(comments) && !isClient && <CommentValue>{t('talentJob.emptyComment')}</CommentValue>}
      <TalentBoardCommentForm talentId={talentId} jobId={jobId} isClient={isClient} />
    </CommentList>
  );
};

const CommentList = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
}));

const CommentValue: FC<TypographyProps> = styled(Typography)(() => ({
  fontSize: '14px',
}));

export default TalentBoardCommentList;
